module.exports = __webpack_public_path__ + "img/提交成功通用状态.c04b0055.png";